import { useState } from 'react'
import { CardContainer, VerticalContainer, VerticalMainContainer } from '@shared/designSystem/Containers'
import { H1Title, H2Title } from '@shared/designSystem/Titles'
import { Text } from '@shared/designSystem/Texts'
import { LeftMenuSection } from '@shared/designSystem/LeftMenuSection'
import { LeftMenuOption } from '@shared/designSystem/LeftMenuOption'
import designSystemStyles from '@shared/styles/designSystemStyles'

const LeftMenuSectionShowcaseScreen = () => {
    const [openSections, setOpenSections] = useState<Record<string, boolean>>({
        comunicacion: true,
        gestion: false,
    })

    const toggleSection = (key: string) => {
        setOpenSections((current) => ({ ...current, [key]: !current[key] }))
    }

    return (
        <VerticalMainContainer>
            <VerticalContainer gap={designSystemStyles.gapSm} alignment="left">
                <H1Title text="LeftMenuSection Showcase" />

                <H2Title text="No controlado (defaultOpen)" />
                <Text text="Cada sección maneja su propio estado. Cerrada muestra el contador de ítems ocultos." />
                <CardContainer>
                    <VerticalContainer width="280px" alignment="left">
                        <LeftMenuSection title="Principal" hiddenCount={2}>
                            <LeftMenuOption label="Resumen" icon="dashboard" onClick={() => undefined} />
                            <LeftMenuOption label="Listado" icon="listado" onClick={() => undefined} />
                        </LeftMenuSection>
                        <LeftMenuSection title="Comunicación" hiddenCount={3} defaultOpen={false}>
                            <LeftMenuOption label="Notificaciones" icon="bell" onClick={() => undefined} />
                            <LeftMenuOption label="Solicitudes" icon="inbox" onClick={() => undefined} />
                            <LeftMenuOption label="Comunicaciones" icon="send" onClick={() => undefined} />
                        </LeftMenuSection>
                        <LeftMenuSection title="Gestión" hiddenCount={2}>
                            <LeftMenuOption label="Colaboradores" icon="people" isActive onClick={() => undefined} />
                            <LeftMenuOption label="Qontact Points" icon="qr" onClick={() => undefined} />
                        </LeftMenuSection>
                    </VerticalContainer>
                </CardContainer>

                <H2Title text="Controlado (isOpen + onToggle)" />
                <Text text="El estado vive afuera, por ejemplo persistido en localStorage por la app." />
                <CardContainer>
                    <VerticalContainer width="280px" alignment="left">
                        <LeftMenuSection
                            title="Comunicación"
                            hiddenCount={2}
                            isOpen={openSections.comunicacion}
                            onToggle={() => toggleSection('comunicacion')}
                        >
                            <LeftMenuOption label="Notificaciones" icon="bell" onClick={() => undefined} />
                            <LeftMenuOption label="Alertas" icon="alert" onClick={() => undefined} />
                        </LeftMenuSection>
                        <LeftMenuSection
                            title="Gestión"
                            hiddenCount={2}
                            isOpen={openSections.gestion}
                            onToggle={() => toggleSection('gestion')}
                        >
                            <LeftMenuOption label="Colaboradores" icon="people" onClick={() => undefined} />
                            <LeftMenuOption label="Novedades" icon="send" onClick={() => undefined} />
                        </LeftMenuSection>
                    </VerticalContainer>
                </CardContainer>

                <H2Title text="Sin contador" />
                <Text text="Sin hiddenCount la cabecera cerrada solo muestra el chevron." />
                <CardContainer>
                    <VerticalContainer width="280px" alignment="left">
                        <LeftMenuSection title="Principal" defaultOpen={false}>
                            <LeftMenuOption label="Resumen" icon="dashboard" onClick={() => undefined} />
                        </LeftMenuSection>
                    </VerticalContainer>
                </CardContainer>
            </VerticalContainer>
        </VerticalMainContainer>
    )
}

export default LeftMenuSectionShowcaseScreen
